import {EyeOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {Modal} from "../../../__snowpack__/pkg/antd.js";
import React, {useContext, useState} from "../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import {RichTextEditorContext} from "./RichTextEditorContext.js";
export default function Preview() {
  const [visible, setVisible] = useState(false);
  const context = useContext(RichTextEditorContext);
  const {formatMessage} = useIntl();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", {
    className: "control-item button",
    "data-title": formatMessage({id: "preview"}),
    onClick: () => setVisible(true)
  }, /* @__PURE__ */ React.createElement(EyeOutlined, null)), /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "preview"}),
    visible,
    width: 940,
    centered: true,
    bodyStyle: {minHeight: 300, maxHeight: "70vh", overflow: "auto"},
    footer: false,
    onCancel: () => {
      setVisible(false);
    }
  }, /* @__PURE__ */ React.createElement("div", {
    dangerouslySetInnerHTML: {__html: context.editorState?.toHTML()}
  })));
}
